import ethereum from "../../media/ethereum.png"
import paypal from "../../media/paypal.png"
import visa from "../../media/visa2.webp"
import world from "../../media/world.png"
import whiteLogo from "../../media/whiteFav2.png"
import whitevisa from "../../media/visawhite.png"
import "../../css/paymentmethod.css"
import { useState, useEffect } from "react"
import Swal from "sweetalert2"
import { doc, updateDoc, getDoc } from "firebase/firestore"
import { db } from "../../firebase/firebase"
import usefbStore from "../../store/firebasestore"

function PaymentMethod() {
    const [step, setNextStep] = useState(0)
    const [selectedMethod, setSelectedMethod] = useState(null)
    const [userMethod, setUserMethod] = useState(null)
    const userID = usefbStore((s) => s.userID)
    const [isLoading, setIsLoading] = useState(false)
    const [isValidatingSwift, setIsValidatingSwift] = useState(false)
    const [swiftValidationMessage, setSwiftValidationMessage] = useState("")
    const [swiftValid, setSwiftValid] = useState(false)
    const paymentMethodSet = usefbStore((s)=>s.paymentMethodSet)
    const paymentMethod = usefbStore((s)=>s.paymentMethod)
    const userBankDetails = usefbStore((s)=>s.userBankDetails)
    const [paypalDetails, setPaypalDetails] = useState({
    accountName: "",
    email: ""
});
const handlePaypalDetailChange = (field, value) => {
    setPaypalDetails(prev => ({
        ...prev,
        [field]: value
    }));
};



    // Bank details state
    const [bankDetails, setBankDetails] = useState({
        bankName: "",
        swiftCode: "",
        accountName: "",
        accountNumber: ""
    })
    
    // Crypto details state
    const [cryptoDetails, setCryptoDetails] = useState({
        walletAddress: ""
    })
    
    // Display values on card
    const [displayAccountName, setDisplayAccountName] = useState("")
    const [displayAccountNumber, setDisplayAccountNumber] = useState("")
    
    // Kenyan Bank Codes with Swift/BIC
        const kenyanBanks = [
            { code: "01", name: "Kenya Commercial Bank (Kenya) Ltd" },
    { code: "02", name: "Standard Chartered Bank Kenya" },
    { code: "03", name: "Absa Bank Kenya Plc" },
    { code: "05", name: "Bank of India" },
    { code: "06", name: "Bank of Baroda Kenya Limited" },
    { code: "07", name: "NCBA Bank Kenya" },
    { code: "10", name: "Prime Bank Limited" },
    { code: "11", name: "Co-operative Bank of Kenya Ltd" },
    { code: "12", name: "National Bank of Kenya Ltd" },
    { code: "14", name: "M-Oriental Bank Ltd" },
    { code: "16", name: "Citibank NA" },
    { code: "17", name: "Habib Bank Limited" },
    { code: "18", name: "Middle East Bank Kenya Ltd" },
    { code: "19", name: "Bank of Africa Kenya Ltd" },
    { code: "23", name: "Consolidated Bank of Kenya Ltd" },
    { code: "25", name: "Credit Bank Limited" },
    { code: "26", name: "Access Bank Kenya" },
    { code: "31", name: "Stanbic Bank Kenya Limited" },
    { code: "35", name: "African Banking Corporation Ltd" },
    { code: "43", name: "Ecobank Kenya Limited" },
    { code: "48", name: "Caritas Microfinance Bank" },
    { code: "49", name: "Spire Bank Kenya" },
    { code: "50", name: "Paramount Universal Bank Ltd" },
    { code: "51", name: "Kingdom Bank" },
    { code: "53", name: "Guaranty Trust Bank Kenya" },
    { code: "54", name: "Victoria Commercial Bank Ltd" },
    { code: "55", name: "Guardian Bank Ltd" },
    { code: "57", name: "I & M Bank Kenya Ltd" },
    { code: "59", name: "Development Bank of Kenya Ltd" },
    { code: "60", name: "SBM Bank Kenya" },
    { code: "61", name: "Housing Finance Cooperation Kenya (HFC Bank)" },
    { code: "62", name: "PostBank Kenya" },
    { code: "63", name: "Diamond Trust Bank Kenya Ltd" },
    { code: "65", name: "Commercial International Bank" },
    { code: "66", name: "Sidian Bank Kenya" },
    { code: "67", name: "UMBA Microfinance Bank" },
    { code: "68", name: "Equity Bank Kenya Ltd" },
    { code: "70", name: "Family Bank Ltd" },
    { code: "72", name: "Gulf African Bank Ltd" },
    { code: "74", name: "Premier Bank Kenya" },
    { code: "75", name: "Dubai Islamic Bank Ltd" },
    { code: "76", name: "UBA Kenya Bank Ltd" },
    { code: "78", name: "Kenya Women Microfinance Bank" },
    { code: "79", name: "Faulu Microfinance Bank" },
    { code: "82", name: "Choice Microfinance Bank" },
    { code: "89", name: "Stima Sacco" },
    { code: "93", name: "Vooma" },
    { code: "97", name: "Telkom Kenya" },
    { code: "138", name: "NCBA Loop" },
    ]
    
    // Load user data on component mount
    useEffect(() => {
        const loadUserData = async () => {
            if (!userID) return;

            try {
                const userRef = doc(db, "Users", userID);
                const userSnap = await getDoc(userRef);

                if (userSnap.exists()) {
                    const data = userSnap.data();

                    if (data.bankDetails) {
                        setBankDetails({
                            bankName: data.bankDetails.bankName || "",
                            swiftCode: data.bankDetails.swiftCode || "",
                            accountName: data.bankDetails.accountName || "",
                            accountNumber: data.bankDetails.accountNumber || ""
                        });

                        setDisplayAccountName(data.bankDetails.accountName || "");
                        setDisplayAccountNumber(data.bankDetails.accountNumber || "");

                        if (data.bankDetails.swiftCode) {
                            const isValid = validateSwiftCode(data.bankDetails.swiftCode);
                            setSwiftValid(isValid);
                        }
                    }

                    if (data.cryptoDetails) {
                        setCryptoDetails({
                            walletAddress: data.cryptoDetails.walletAddress || ""
                        });
                    }
                    if (data.paypalDetails) {
    setPaypalDetails({
        accountName: data.paypalDetails.accountName || "",
        email: data.paypalDetails.email || ""
    });
}
                }
            } catch (err) {
                console.error("Error loading user data:", err);
            }
        };

        loadUserData();
    }, [userID]);

    // Swift/BIC validation function
    const validateSwiftCode = (swiftCode) => {
        const swiftRegex = /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/
        return swiftRegex.test(swiftCode.toUpperCase())
    }

    // Auto-populate Swift code when bank is selected
    useEffect(() => {
        if (bankDetails.bankName && !bankDetails.swiftCode) {
            const selectedBank = kenyanBanks.find(bank => bank.name === bankDetails.bankName)
            if (selectedBank && selectedBank.swiftCode) {
                setBankDetails(prev => ({
                    ...prev,
                    swiftCode: selectedBank.swiftCode
                }))
                setSwiftValid(true)
                setSwiftValidationMessage("Swift/BIC code automatically populated")
                setTimeout(() => setSwiftValidationMessage(""), 3000)
            }
        }
    }, [bankDetails.bankName])

    // Manual Swift code validation
    const handleSwiftCodeChange = (value) => {
        const upperValue = value.toUpperCase()
        setBankDetails(prev => ({
            ...prev,
            swiftCode: upperValue
        }))
        
        if (upperValue.length >= 8) {
            const isValid = validateSwiftCode(upperValue)
            setSwiftValid(isValid)
            if (isValid) {
                setSwiftValidationMessage("Valid Swift/BIC code format")
            } else {
                setSwiftValidationMessage("Invalid Swift/BIC code format")
            }
        } else if (upperValue.length > 0) {
            setSwiftValid(false)
            setSwiftValidationMessage("Swift/BIC code must be at least 8 characters")
        } else {
            setSwiftValid(false)
            setSwiftValidationMessage("")
        }
    }

    const handleMethodSelect = (method) => {
        setSelectedMethod(method)
        
        if (method === "bank") {
            setNextStep(1)
        } else if (method === "crypto") {
            setNextStep(2)
        }else if(method === "paypal"){
            setNextStep(3)
        }
    }

    const handleBankDetailChange = (field, value) => {
        setBankDetails(prev => ({
            ...prev,
            [field]: value
        }))
        
        // Update display on card
        if (field === "accountName") {
            setDisplayAccountName(value)
        }
        if (field === "accountNumber") {
            setDisplayAccountNumber(value)
        }
    }

    const handleCryptoDetailChange = (value) => {
        setCryptoDetails(prev => ({
            ...prev,
            walletAddress: value
        }))
    }

    const validateBankDetails = () => {
        if (!bankDetails.bankName) {
            Swal.fire("Missing Info", "Please select your bank.", "warning")
            return false
        }
        if (!bankDetails.swiftCode) {
            Swal.fire("Missing Info", "Please enter the Swift/BIC code.", "warning")
            return false
        }
        if (!validateSwiftCode(bankDetails.swiftCode)) {
            Swal.fire("Invalid Swift/BIC", "Please enter a valid Swift/BIC code (8 or 11 characters).", "warning")
            return false
        }
        if (!bankDetails.accountName.trim()) {
            Swal.fire("Missing Info", "Please enter the account name.", "warning")
            return false
        }
        if (!bankDetails.accountNumber.trim()) {
            Swal.fire("Missing Info", "Please enter the account number.", "warning")
            return false
        }
        if (bankDetails.accountNumber.length < 10) {
            Swal.fire("Invalid Account", "Account number should be at least 10 digits.", "warning")
            return false
        }
        return true
    }

    const validateCryptoDetails = () => {
        if (!cryptoDetails.walletAddress.trim()) {
            Swal.fire("Missing Info", "Please enter your Ethereum wallet address.", "warning")
            return false
        }
        if (!cryptoDetails.walletAddress.startsWith("0x") || cryptoDetails.walletAddress.length !== 42) {
            Swal.fire("Invalid Address", "Please enter a valid Ethereum wallet address (0x...).", "warning")
            return false
        }
        return true
    }
    const validatePaypalDetails = () => {

    if (!paypalDetails.accountName.trim()) {
        Swal.fire(
            "Missing Info",
            "Please enter your PayPal account name.",
            "warning"
        );

        return false;
    }

    if (!paypalDetails.email.trim()) {
        Swal.fire(
            "Missing Info",
            "Please enter your PayPal email address.",
            "warning"
        );

        return false;
    }

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(paypalDetails.email.trim())) {
        Swal.fire(
            "Invalid Email",
            "Please enter a valid PayPal email address.",
            "warning"
        );

        return false;
    }

    return true;
};

   const savePaymentMethod = async () => {

    if (!userID) {
        Swal.fire(
            "Error",
            "User not authenticated. Please log in again.",
            "error"
        );

        return;
    }

    // Validate selected payment method
    if (selectedMethod === "bank") {

        if (!validateBankDetails()) return;

    } else if (selectedMethod === "crypto") {

        if (!validateCryptoDetails()) return;

    } else if (selectedMethod === "paypal") {

        if (!validatePaypalDetails()) return;

    } else {

        Swal.fire(
            "No Method Selected",
            "Please select a payment method first.",
            "warning"
        );

        return;
    }

    setIsLoading(true);

    Swal.fire({
        title: "Processing",
        text: "Saving your payment method...",
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
            Swal.showLoading();
        }
    });

    try {

        const userRef = doc(db, "Users", userID);

        const userSnap = await getDoc(userRef);

        if (!userSnap.exists()) {
            throw new Error("User not found");
        }


        const paymentData = {
            paymentMethodSet: true,

            paymentMethod:
                selectedMethod === "bank"
                    ? "Bank Transfer"
                    : selectedMethod === "crypto"
                    ? "Crypto Currency"
                    : "PayPal",

            updatedAt: new Date().toISOString()
        };


        // =========================
        // BANK
        // =========================

        if (selectedMethod === "bank") {

            const selectedBank = kenyanBanks.find(
                b => b.name === bankDetails.bankName
            );

            paymentData.bankDetails = {

                bankName: bankDetails.bankName,

                swiftCode:
                    bankDetails.swiftCode.toUpperCase(),

                accountName:
                    bankDetails.accountName,

                accountNumber:
                    bankDetails.accountNumber,

                bankCode:
                    selectedBank?.code || "",

                country: "Kenya",

                currency: "KES"
            };

            // Clear other payment details
            paymentData.cryptoDetails = null;
            paymentData.paypalDetails = null;
        }


        // =========================
        // CRYPTO
        // =========================

        else if (selectedMethod === "crypto") {

            paymentData.cryptoDetails = {

                walletAddress:
                    cryptoDetails.walletAddress,

                network: "Ethereum (ERC-20)",

                currency: "ETH"
            };

            // Clear other payment details
            paymentData.bankDetails = null;
            paymentData.paypalDetails = null;
        }


        // =========================
        // PAYPAL
        // =========================

        else if (selectedMethod === "paypal") {

            paymentData.paypalDetails = {

                accountName:
                    paypalDetails.accountName.trim(),

                email:
                    paypalDetails.email.trim().toLowerCase()
            };

            // Clear other payment details
            paymentData.bankDetails = null;
            paymentData.cryptoDetails = null;
        }


        // Save to Firestore
        await updateDoc(userRef, paymentData);


        Swal.close();

        await Swal.fire({
            title: "Payment Method Saved!",
            text: `Your ${
                selectedMethod === "bank"
                    ? "bank account"
                    : selectedMethod === "crypto"
                    ? "crypto wallet"
                    : "PayPal account"
            } has been successfully added.`,

            icon: "success",

            confirmButtonColor: "#6a5acd"
        });


        // =========================
        // RESET FORM
        // =========================

        setNextStep(0);

        setSelectedMethod(null);

        setBankDetails({
            bankName: "",
            swiftCode: "",
            accountName: "",
            accountNumber: ""
        });

        setCryptoDetails({
            walletAddress: ""
        });

        setPaypalDetails({
            accountName: "",
            email: ""
        });

        setDisplayAccountName("");

        setDisplayAccountNumber("");

        setSwiftValid(false);

        setSwiftValidationMessage("");


    } catch (error) {

        console.error(
            "Save error details:",
            error
        );

        Swal.close();

        Swal.fire({
            title: "Save Failed",

            text:
                error.message ||
                "Something went wrong. Please try again.",

            icon: "error",

            confirmButtonColor: "#6a5acd"
        });

    } finally {

        setIsLoading(false);
    }
};

    const goBack = () => {
        setNextStep(0)
        setSelectedMethod(null)
        setBankDetails({
            bankName: "",
            swiftCode: "",
            accountName: "",
            accountNumber: ""
        })
        setCryptoDetails({
            walletAddress: ""
        })
        setDisplayAccountName("")
        setDisplayAccountNumber("")
        setSwiftValid(false)
        setSwiftValidationMessage("")
    }

    const getMaskedAccountNumber = (number) => {
        if (!number) return "XXXX XXXX XXXX"
        const last4 = number.slice(-4)
        const masked = "XXXX XXXX " + last4
        return masked
    }

    return (
        <div className="paymentMethodWrap">
            <div className="pmwWrap">
                <div className="chooseMethodWrap">
                    {step === 0 && (
                        <>
                            <div className="methodTitle">
                                <span>How would you like to get paid?</span>
                            </div>
                            <div className="methods">
                            
                                
                                <div 
                                    className={`methodBox ${paymentMethod === "Crypto Currency" ? "methodBoxActive" : ""}`}
                                    onClick={() => handleMethodSelect("crypto")}
                                >
                                    <div className="methodWrap">
                                        <div className="mwTopIcon">
                                            <img src={ethereum} alt="" />
                                        </div>
                                        <div className="mwBtmCont">
                                            <span>Crypto Currency</span>
                                            <p>You need to have an active Ethereum wallet address to receive funds.</p>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="methodBox"

                                 className={`methodBox ${paymentMethod === "PayPal" ? "methodBoxActive" : ""}`}
                                 onClick={() => handleMethodSelect("paypal")}
                                
                                >
                                    <div className="methodWrap">
                                        <div className="mwTopIcon">
                                            <img src={paypal} alt="" />
                                        </div>
                                        <div className="mwBtmCont">
                                            <span>PayPal</span>
                                           <p>Get your earnings securely through your active PayPal account.</p>
                                        </div>
                                    </div>
                                </div>
                                    <div 
                                    className={`methodBox ${paymentMethod === "Bank Transfer" ? "methodBoxActive" : ""} methodBoxDisabled`}
                                    onClick={() => handleMethodSelect("bank")}
                                >
                                    <div className="methodWrap">
                                        <div className="mwTopIcon">
                                            <img src={visa} alt="" />
                                        </div>
                                        <div className="mwBtmCont">
                                            <span>Bank Transfers</span>
                                            <p>Coming soon! This method is only available for select banks based on your region.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                       
                        </>
                    )}
                    
                    {step === 1 && (
                        <>
                            <div className="cardPaymentWrap">
                                <div className="cpwTop">
                                    <div className="cpwCard">
                                        <div className="cpwCardCont">
                                            <img className="cardLogo" src={whiteLogo} alt="" />
                                            <img className="cardWorld" src={world} alt="" />
                                            <img className="visaCard" src={whitevisa} alt="" />
                                            <div className="cpwCardContDet">
                                                <div className="cpwCardContInfo">
                                                    <p className="cpwCardContDetNo">
                                                        {getMaskedAccountNumber(displayAccountNumber)}
                                                    </p>
                                                    <span>Account Number</span>
                                                </div>
                                                <div className="cpwCardContInfo">
                                                    <p>{displayAccountName || "Account Name"}</p>
                                                    <span>Name</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="cpwBtm">
                                    <div className="cpwInputWraps">
                                        <div className="cpwinputBox">
                                            <p>Your Bank:</p>
                                            <div className="cpwInputCont">
                                                <select 
                                                    value={bankDetails.bankName}
                                                    onChange={(e) => handleBankDetailChange("bankName", e.target.value)}
                                                >
                                                    <option value="">Select Bank</option>
                                                    {kenyanBanks.map((bank, index) => (
                                                        <option key={index} value={bank.name}>
                                                            {bank.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        
                                        <div className="cpwinputBox">
                                            <p>Swift/BIC Code:</p>
                                            <div className="cpwInputCont">
                                                <input 
                                                    type="text" 
                                                    placeholder="e.g., KCBLKENX"
                                                    value={bankDetails.swiftCode}
                                                    onChange={(e) => handleSwiftCodeChange(e.target.value)}
                                                    className={swiftValid ? "validInput" : swiftValidationMessage && !swiftValid ? "invalidInput" : ""}
                                                    maxLength="11"
                                                />
                                                {swiftValidationMessage && (
                                                    <small className={swiftValid ? "validMessage" : "invalidMessage"}>
                                                        {swiftValidationMessage}
                                                    </small>
                                                )}
                                            </div>
                                        </div>
                                        
                                        <div className="cpwinputBox">
                                            <p>Account Name:</p>
                                            <div className="cpwInputCont">
                                                <input 
                                                    type="text" 
                                                    placeholder="Bank account name"
                                                    value={bankDetails.accountName}
                                                    onChange={(e) => handleBankDetailChange("accountName", e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        
                                        <div className="cpwinputBox">
                                            <p>Account Number:</p>
                                            <div className="cpwInputCont">
                                                <input 
                                                    type="text" 
                                                    placeholder="Account Number"
                                                    value={bankDetails.accountNumber}
                                                    onChange={(e) => handleBankDetailChange("accountNumber", e.target.value)}
                                                    pattern="[0-9]+"
                                                    title="Please enter only numbers"
                                                />
                                            </div>
                                        </div>
                                     
                            
                                        <div className="cpwButtons">
                                            <button className="backButton" onClick={goBack}>Back</button>
                                            <button 
                                                className="saveButton" 
                                                onClick={() => savePaymentMethod()}
                                                disabled={isLoading || (bankDetails.swiftCode && !swiftValid)}
                                            >
                                                {isLoading ? "Saving..." : "Save"}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                    
                    {step === 2 && (
                        <>
                            <div className="cardPaymentWrap">
                                <div className="cpwTop cryptoCard">
                                    <div className="cryptoInfo">
                                        <img src={ethereum} alt="Ethereum" className="cryptoIcon" />
                                        <h3>Ethereum</h3>
                                        <p>Funds will be sent to this wallet address</p>
                                    </div>
                                </div>
                                
                                <div className="cpwBtm">
                                    <div className="cpwInputWraps">
                                        <div className="cpwinputBox">
                                            <p>Wallet Address:</p>
                                            <div className="cpwInputCont">
                                                <input 
                                                    type="text" 
                                                    placeholder="0x..."
                                                    value={cryptoDetails.walletAddress}
                                                    onChange={(e) => handleCryptoDetailChange(e.target.value)}
                                                />
                                                <small>Enter your Ethereum wallet address (starts with 0x)</small>
                                            </div>
                                        </div>
                                        
                                        <div className="cpwButtons">
                                            <button className="backButton" onClick={goBack}>Back</button>
                                            <button 
                                                className="saveButton" 
                                                onClick={() => savePaymentMethod()}
                                                disabled={isLoading}
                                            >
                                                {isLoading ? "Saving..." : "Save"}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                   {step === 3 && (
    <>
        <div className="cardPaymentWrap">

            <div className="cpwTop paypalCard">
                <div className="cryptoInfo">
                    <img
                        src={paypal}
                        alt="Paypal"
                        className="cryptoIcon"
                    />

                    <h3>PayPal</h3>

                    <p>
                        Funds will be sent to your PayPal email address
                    </p>
                </div>
            </div>

            <div className="cpwBtm">

                <div className="cpwInputWraps">

                    {/* Account Name */}
                    <div className="cpwinputBox">
                        <p>Account Name:</p>

                        <div className="cpwInputCont">

                            <input
                                type="text"
                                placeholder="PayPal account name"
                                value={paypalDetails.accountName}
                                onChange={(e) =>
                                    handlePaypalDetailChange(
                                        "accountName",
                                        e.target.value
                                    )
                                }
                            />

                            <small>
                                Enter the name associated with your PayPal account
                            </small>

                        </div>
                    </div>


                    {/* PayPal Email */}
                    <div className="cpwinputBox">
                        <p>PayPal Email:</p>

                        <div className="cpwInputCont">

                            <input
                                type="email"
                                placeholder="mypaypal@gmail.com"
                                value={paypalDetails.email}
                                onChange={(e) =>
                                    handlePaypalDetailChange(
                                        "email",
                                        e.target.value
                                    )
                                }
                            />

                            <small>
                                Enter the email address associated with your PayPal account
                            </small>

                        </div>
                    </div>


                    {/* Buttons */}
                    <div className="cpwButtons">

                        <button
                            className="backButton"
                            onClick={goBack}
                        >
                            Back
                        </button>

                        <button
                            className="saveButton"
                            onClick={() => savePaymentMethod()}
                            disabled={isLoading}
                        >
                            {isLoading ? "Saving..." : "Save"}
                        </button>

                    </div>

                </div>

            </div>

        </div>
    </>
)}

                </div>
            </div>
        </div>
    )
}

export default PaymentMethod